import { resolveId } from '@medplum/core'
import { Order } from '@seen/core/models/orders/Order'
import type { QueryTypes } from '@seen/core/search'
import { useMemo } from 'react'
import { useSearch } from '#src/hooks/useSearch.ts'

interface UseRelatedOrdersOptions {
  order: Order
  limit?: number
}

interface UseRelatedOrdersResult {
  data: Order[] | undefined
  isLoading: boolean
  error: Error | null
}

export function useRelatedOrders({
  order,
  limit = 10,
}: UseRelatedOrdersOptions): UseRelatedOrdersResult {
  const filterQuery = useMemo<QueryTypes>(() => {
    const baseQuery: QueryTypes = {
      patient: order.participant,
      category: order.category,
      _sort: '-_lastUpdated',
      'status:not': ['entered-in-error', 'revoked'],
      '_id:not': resolveId(order.reference),
      _count: 500,
    }

    return baseQuery
  }, [order])

  const { data, isLoading, error } = useSearch(Order, filterQuery)

  const relatedOrders = useMemo(
    () => (data?.filter((o) => order.isRelated(o)) ?? []).slice(0, limit),
    [data, order, limit]
  )

  return {
    data: relatedOrders,
    isLoading,
    error,
  }
}
